module.exports = __webpack_public_path__ + "static/fonts/Arita-buriSB.09db4d6.woff";